export const TEMPLATE_CATEGORIES = [
  "Reminders",
  "Alerts",
  "Onboarding",
  "Notifications",
  "Billing",
  "Reports",
] as const;

export type TemplateCategory = (typeof TEMPLATE_CATEGORIES)[number];

export const getTemplateCategories = (): string[] => {
  return [...TEMPLATE_CATEGORIES];
};
